import { createAction, props } from '@ngrx/store';
import { IStripeCustomer } from 'app/models/stripeCustomer';

export const clearAllItems = createAction('[DalHelper] Clear All Stripe Customers');

export const loadItemFromUser = createAction('[Module Component] Load Stripe Customer from User');
export const loadItem = createAction('[Module Component] Load Stripe Customer', props<{ id: string }>());
export const loadItemSuccess = createAction('[Stripe API] Load Load Stripe Customer Success', props<{ item: IStripeCustomer }>());
export const loadItemFailure = createAction('[Stripe API] Load Load Stripe Customer Failure', props<{ error: any }>());

